import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ExtendedService } from '../../interfaces';

@Component({
  selector: 'fin-meal-details',
  styleUrls: ['meal-details.component.scss'],
  templateUrl: 'meal-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MealDetailsComponent {
  @Input()
  meal: ExtendedService;
}
